module.exports = __webpack_public_path__ + "img/hr-red-desert-0.2c7209d7.png";